document.addEventListener('DOMContentLoaded', function () {
  bindFacetChangeEvent();
});

function bindFacetChangeEvent() {
  if (window.WP_Grid_Builder) {
    WP_Grid_Builder.on('init', (wpgb) => {
      // Define the toggleGridDisplay function globally

      function toggleGridDisplay() {
        const searchInput = document.querySelector(
          '.wpgb-search-facet .wpgb-input'
        );
        if (searchInput) {
          searchInput.focus();
        }
        const gridDiv = document.querySelector('#results');

        if (!searchInput || !gridDiv) return; // Ensure searchInput is not null

        if (searchInput.value.trim() === '') {
          gridDiv.classList.add('invisible'); // Hide grid if search input is empty
          gridDiv.classList.remove('visible');
        } else {
          gridDiv.classList.remove('invisible'); // Show grid if search input is not empty
          gridDiv.classList.add('visible');
        }
      }

      // Listen for facet change event
      wpgb.facets.on('change', function (slug, values) {
        // console.log('wpgb facets on change');
        // Call toggleGridDisplay on facet change
        toggleGridDisplay();
      });

      // Listen for facets loaded event
      wpgb.facets.on('loaded', function (facets) {
        // console.log('wpgb facets on loaded');
        // Call toggleGridDisplay on facets loaded
        toggleGridDisplay();
      });

      // Call toggleGridDisplay initially on page load
      toggleGridDisplay();
    });
  }
}
